module.exports = __webpack_public_path__ + "img/user-3.9d3aafd6.svg";